export default __webpack_public_path__ + "static/media/canoe.23df06ed.png";